import { AppBox, AppText } from "../../../../commons/components";
import { IFootballCompetition } from "../../../../commons/models/football/interface/i-football-competition";

interface TournamentDeleteProps {
  tournament: IFootballCompetition;
}
export default function TournamentDeleteInprogress({
  tournament,
}: TournamentDeleteProps) {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>
        Deleting <strong>“{tournament.title}”</strong> In Progress
      </AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
